import React from 'react';
import styled from 'styled-components';
import {
  breakpoint,
  LogoIcon,
  PrimaryButton,
} from '@grays-npm/component-library';
import { useCMSData } from '../../../state/content-manager';

const StyledHeader = styled.header`
  background-color: ${({ theme }) => theme.colors.primary.graysRed};
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: ${({ theme: { spacings } }) =>
    `${spacings[2].rem} ${spacings[4].rem}`};
  width: 100%;

  svg {
    fill: white;
    width: 68px;

    ${breakpoint('lg')`
      width: 85px;
    `}
  }

  ${breakpoint('lg')`
    padding: ${({ theme: { spacings } }) =>
      `${spacings[5].rem} ${spacings[7].rem}`};
  `}
`;

const StyledPrimaryButton = styled(PrimaryButton)`
  ${({ theme: { buttons } }) => breakpoint('lg')`
      font-size: ${buttons.fontSize.medium}px;
      line-height: ${buttons.lineHeight.medium}px;
      min-height: ${buttons.height.medium}px;
      padding: ${buttons.padding.medium};
  `}
`;

const Header: React.FC = () => {
  const { switchToBuyingUrl } = useCMSData();
  const handleSwitch = () => {
    window.location.href = switchToBuyingUrl;
  };

  return (
    <StyledHeader>
      <Content>
        <a href="/">
          <LogoIcon />
        </a>
        <StyledPrimaryButton
          contextColor="red"
          fullWidth={false}
          onClick={handleSwitch}
          size="small"
        >
          Switch to buying
        </StyledPrimaryButton>
      </Content>
    </StyledHeader>
  );
};

export default Header;
